enum ActionList {
    USER_LOGOUT                     = 'USER_LOGOUT',
    CONTACT_LOADING                 = 'CONTACT_LOADING',
    CONTACT_LOADED                  = 'CONTACT_LOADED',
    CONTACT_LOAD_ERROR              = 'CONTACT_LOAD_ERROR',
    RECIPIENT_LOADING               = 'RECIPIENT_LOADING',
    RECIPIENT_LOADED                = 'RECIPIENT_LOADED',
    RECIPIENT_LOAD_ERROR            = 'RECIPIENT_LOAD_ERROR',
    MESSAGES_LOADED                 = 'MESSAGES_LOADED',
    MESSAGES_LOAD_ERROR             = 'MESSAGES_LOAD_ERROR',
    MESSAGES_UPDATE                 = 'MESSAGES_UPDATE',
    MESSAGES_SEND_REQUEST           = 'MESSAGES_SEND_REQUEST',
    MESSAGES_SEND_ERROR             = 'MESSAGES_SEND_ERROR',
    MESSAGES_SEND_SUCCESS           = 'MESSAGES_SEND_SUCCESS',
    CONVERSATIONSLIST_LOAD          = 'CONVERSATIONSLIST_LOAD',
    CONVERSATIONSLIST_LOAD_MESSAGE  = 'CONVERSATIONSLIST_LOAD_MESSAGE',
    CONVERSATIONSLIST_LOAD_SUCCESS  = 'CONVERSATIONSLIST_LOAD_SUCCESS',
    CONVERSATIONSLIST_LOAD_ERROR    = 'CONVERSATIONSLIST_LOAD_ERROR',
    CONVERSATIONSLIST_RESET_UNREAD  = 'CONVERSATIONSLIST_RESET_UNREAD',
    CONVERSATIONSLIST_SET_ACTIVE    = 'CONVERSATIONSLIST_SET_ACTIVE',
    CONVERASATIONSLIST_MAP_COUNTER  = 'CONVERSATIONSLIST_MAP_COUNTER',
    CUSTOM_FIELDS_MAP               = 'CUSTOM_FIELDS_MAP',
    CUSTOM_FIELDS_UPDATE            = 'CUSTOM_FIELDS_UPDATE',
    CUSTOM_FIELDS_VALIDATE          = 'CUSTOM_FIELDS_VALIDATE',
    CUSTOM_FIELDS_SELECT            = 'CUSTOM_FIELDS_SELECT',
    CUSTOM_FIELDS_RESET             = 'CUSTOM_FIELDS_RESET',
    NEXT_CONVO_LOADING              = 'NEXT_CONVO_LOADING',
    NEXT_CONVO_LOADING_ERROR        = 'NEXT_CONVO_LOADING_ERROR',
    NEXT_CONVO_ID_LOADED            = 'NEXT_CONVO_ID_LOADED',
    NEXT_CONVO_LOADED               = 'NEXT_CONVO_LOADED',
    SMART_LIST_STATUS_LOADED        = 'SMART_LIST_STATUS_LOADED',
    SMART_LIST_STATUS_ERROR         = 'SMART_LIST_STATUS_ERROR',
    TRANSLATIONS_LOADING            = 'TRANSLATIONS_LOADING',
    TRANSLATIONS_LOADED             = 'TRANSLATIONS_LOADED',
    TRANSLATIONS_ERROR              = 'TRANSLATIONS_ERROR'
}

export default ActionList;



// WEBPACK FOOTER //
// ./src/ActionTypes.ts